import { render } from "./HealthInsuranceHistory.vue?vue&type=template&id=66cc31aa&scoped=true"
import script from "./HealthInsuranceHistory.vue?vue&type=script&lang=js"
export * from "./HealthInsuranceHistory.vue?vue&type=script&lang=js"

import "./HealthInsuranceHistory.vue?vue&type=style&index=0&id=66cc31aa&lang=scss&scoped=true"

import exportComponent from "../../../../../../MemberPortal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cc31aa"]])

export default __exports__